import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blue-greenLine",
  "use": "blue-greenLine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"blue-greenLine\"><path d=\"M512 1024 200.192 311.808 512 0l311.808 311.808z\" fill=\"rgba(7,128,158,0.63)\" /><path d=\"M512 0 200.192 311.808 512 1024l311.808-712.192L512 0zm11.776 44.544L778.752 299.52l-254.976 72.192V44.544zm-23.552 0v327.68l-254.976-71.68 254.976-256zm23.552 351.744L794.624 320 523.776 939.52V396.288zm-23.552 0V939.52L229.376 320l270.848 76.288z\" fill=\"#00a4f2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol